import { Suspense } from "react";
import UniversalLoading from "@/components/loading/UniversalLoading";
import FavouritesPage from "@/components/favourites/FavouritesPage";
import DashboardHeader from "@/components/dashboard/layout/DashboardHeader";
import { usePicassoAuth } from "@/hooks/common/usePicassoAuth";

export const FavouritesView = () => {
  const { isAdmin, userEmail } = usePicassoAuth();

  return (
    <div className="w-full bg-transparent flex flex-col min-h-screen">
      {/* Navigation header - Always use Dashboard header on favourites page */}
      <DashboardHeader isAdmin={isAdmin} userEmail={userEmail} />

      {/* Main content area */}
      <main className="flex-1 w-full bg-white">
        <Suspense
          fallback={
            <div className="overflow-y-hidden">
              <UniversalLoading 
                variant={isAdmin ? "admin" : "dashboard"} 
                message="Loading favourites..." 
              />
            </div>
          }
        >
          <FavouritesPage isAdmin={isAdmin} userEmail={userEmail} />
        </Suspense>
      </main>
    </div>
  );
};

export default FavouritesView;
